import { ClientsService } from '@/services';

const INITIAL_STATE = {
  isLoadingClients: false,
  clients: null,
};

const store = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations: {
    SET_CLIENTS(state, value) {
      state.clients = value;
    },

    SET_LOADING_CLIENTS(state, value) {
      state.isLoadingClients = value;
    },
  },
  actions: {
    async fetchClients({ commit }, companyId) {
      commit('SET_LOADING_CLIENTS', true);

      try {
        const clients = await ClientsService.fetchCompanyClients(companyId);
        commit('SET_CLIENTS', clients);
      } catch (err) {
        console.log(err);
      }

      commit('SET_LOADING_CLIENTS', false);
    },
    createClient() {

    },
    updateClientInfo() {

    },
    deactivateClient() {

    },
    assignClientToBroker() {

    },
  },
};

export default store;
